/**
 * Debug helper to log schedule data at various stages
 */

export function debugScheduleData(label, data) {
  // Debug function disabled to reduce console pollution
}

/**
 * Debug calendar events
 */
export function debugCalendarEvents(events) {
  // Debug function disabled to reduce console pollution
}

// Add to window for easy access in console
if (typeof window !== 'undefined') {
  window.debugScheduleData = debugScheduleData;
  window.debugCalendarEvents = debugCalendarEvents;
}